import React, { useEffect, useRef, useState } from "react";
import _get from "lodash/get";
import _toArray from "lodash/toArray";
import WebChatEmoji from "../WebChatEmoji";
import ContentEditable from "../Conversation/Templates/Common/ContentEditable";
import { ALLOWED_KEY_CODES, CAPTION_CHARACTER_LIMIT } from "../../../Helpers/Constants";
import { setCaretPosition, removeMoreNumberChar, positionCursorAfterLastMention, getCaretPosition } from "../../../Helpers/Chat/ContentEditableEle";
import OutsideClickHandler from "react-outside-click-handler";
import MentionUserList from "../Conversation/Templates/Common/MentionUserList";
import { getUserDetails } from "../../../Helpers/Chat/User";
import { useSelector } from "react-redux";
import { placeCaretAtEnd } from "../../../Helpers/Utility";
import { CHAT_TYPE_GROUP } from "../../../Helpers/Chat/Constant";
import PropTypes from "prop-types";

const Caption = (props = {}) => {
  const { onChangeCaption, media = {}, onClickSend, chatType, uniqueId, chatId, newFile, selectedFiles } = props;
  const { caption = "" } = media;
  const [typingMessage, setTypingMessage] = useState({
    value: ""
  });
  const [selectedText, setSelectedText] = useState(null);
  const [position, setPosition] = useState(0);
  // Keep the live caption DOM Range so emoji insertion can target the real caret
  // even after the emoji picker click moves focus out of the contenteditable.
  const savedRangeRef = useRef(null);
  const captureCaptionRange = () => {
    try {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return;
      const capEl = document.getElementById(getActualElementId());
      const range = sel.getRangeAt(0);
      if (capEl && capEl.contains(range.commonAncestorContainer)) {
        savedRangeRef.current = range.cloneRange();
      }
    } catch (e) {
      /* ignore selection read errors */
    }
  };
  const setCursorPosition = (pos) => {
    setPosition(pos);
    captureCaptionRange();
  };
  const [groupMemberList, setGroupMemberList] = useState([]);
  const [MentionView, setMentionView] = useState(false)
  const [MentionViewClicked, setMentionViewClicked] = useState(false)
  const [emojiSelected, setEmojiSelected] = useState(false);
  const [showEmojiState, setShowEmojiState] = useState(false);
  const [mentionedUsersIds, setMentionedUsersIds] = useState([])
  const groupList = useSelector((state) => state.groupsMemberListData);
  const vcardData = useSelector((state) => state.vCardData)
  const groupMembers = useSelector((state) => state.groupsMemberListData)
  const { typedMessage = "" } = useSelector((state) => state.chatConversationHistory?.data[chatId] || {})
  const [showCursor, setshowCursor] = useState(false);
  const [searchEmoji, setSearchEmoji] = useState("");
  const [filteredTextForSearch, setFilteredTextForSearch] = useState("");
  const [id, setId] = useState("image-preview-typingContainer");
  const captionRef = useRef(null);

  // Resolve the actual DOM element ID.
  // ContentEditable.jsx line 680 strips the uniqueId suffix when the id
  // contains 'image-preview-typingContainer', so we must match that logic.
  const getActualElementId = () => {
    const fullId = `${id}-${uniqueId}`;
    return fullId.includes('image-preview-typingContainer')
      ? 'image-preview-typingContainer'
      : fullId;
  };

  const isFirstFile = selectedFiles && selectedFiles[0]?.fileDetails?.fileId === uniqueId;

  const handleEmojiText = (emojiObject, isClicked = false) => {
    setEmojiSelected(isClicked)
    const { value: typeVal } = typingMessage;
    let positionToUpdate;
    let text = "";
    const msgContent = document.getElementById(getActualElementId());

    // Preferred path: insert the emoji at the real DOM caret via the Range API.
    // Splicing the emoji into the HTML string at a mismatched innerHTML offset
    // corrupts mention <span> markup (e.g. "<spa🎊n data-mentioned=...>"), which
    // then shows the raw <span> text in the caption input. If we can't find a valid
    // caret inside the caption, append at the end instead of splicing the HTML.
    if (msgContent) {
      const projectedLength = _toArray((msgContent.textContent || "") + emojiObject).length;
      if (projectedLength > CAPTION_CHARACTER_LIMIT) return;

      const selection = window.getSelection();
      // Append the emoji at the END of the caption. The caret can't be tracked
      // reliably while/after a mention search (it sits at the "@", so inserting at the
      // saved/live range drops the emoji inside the mention <span>). Appending at the
      // end matches how users add emojis and never corrupts a mention.
      placeCaretAtEnd(msgContent);
      const targetRange = window.getSelection().getRangeAt(0);

      selection.removeAllRanges();
      selection.addRange(targetRange);
      targetRange.deleteContents(); // removes selected text, if any
      const emojiNode = document.createTextNode(emojiObject);
      targetRange.insertNode(emojiNode);
      targetRange.setStartAfter(emojiNode);
      targetRange.setEndAfter(emojiNode);
      targetRange.collapse(true);
      selection.removeAllRanges();
      selection.addRange(targetRange);
      savedRangeRef.current = targetRange.cloneRange();

      const newValue = msgContent.innerHTML;
      const mentionedSpans = msgContent.querySelectorAll('span[data-mentioned]');
      const currentMentionedIds = Array.from(mentionedSpans).map(span => span.getAttribute('data-mentioned'));
      setPosition(getCaretPosition(msgContent));
      setTypingMessage((prevState) => ({ ...prevState, value: newValue }));
      onChangeCaption(media, newValue, currentMentionedIds);
      msgContent.focus();
      return;
    }
    // When user select all the text & choose emoji means,
    // Need to replace the emoji with existing content.
    // That's why below we check condition, selectedText & current state typingMessage is equal
    // Need to clear other content message & enter only the emoji
    if (selectedText === typeVal) {
      text = emojiObject;
      positionToUpdate = emojiObject.length;
    } else {
      const start = typeVal.substring(0, position);
      const end = typeVal.substring(position);
      text = start + emojiObject + end;
      positionToUpdate = position + emojiObject.length;
    }
    let filteredHtml = "";
    if (_toArray(text).length <= CAPTION_CHARACTER_LIMIT) {
      setTypingMessage((prevState) => {
        setCursorPosition(positionToUpdate);
        setCaretPosition(msgContent, positionToUpdate);
        return {
          ...prevState,
          value: text
        };
      });
      onChangeCaption(media, text);

      if ((typingMessage.value.length === position) && chatType === CHAT_TYPE_GROUP) {
        const atIndex = text.lastIndexOf('@') - 1;
        const findBeforeAt = text.charAt(atIndex);
        filteredHtml = text.toString().includes('@') && text.substring(text.lastIndexOf('@') + 1, positionToUpdate);
        if (filteredHtml !== undefined && filteredHtml.length > 0 &&
          MentionView === true && groupMemberList.length < 1 && (findBeforeAt === "" || findBeforeAt === " ")) {
          setFilteredTextForSearch(filteredHtml);
          setMentionView(true);
        }
      } else if ((typingMessage.value.length !== position) && chatType === CHAT_TYPE_GROUP) {
        const atIndex = text.lastIndexOf('@', position);
        const checkBeforeAt = text.charAt(atIndex - 1);
        const result = text.substring(atIndex + 1, positionToUpdate);
        filteredHtml = result;
        if (filteredHtml !== undefined && filteredHtml.length > 0 &&
          MentionView === true && groupMemberList.length < 1 &&
          (checkBeforeAt.includes(' ') === true || checkBeforeAt === "")) {
          setFilteredTextForSearch(filteredHtml);
          setMentionView(true);
        }
      }


    }
  };
  const handleMentionedUser = (userId, chatName = '', isClicked = false) => {
    setMentionViewClicked(isClicked);
    let rosterDataValue = getUserDetails(userId);
    let displayName = rosterDataValue.displayName;
    let positionToUpdate;
    let text = '';
    let msgElement = typingMessage.value;
    let startCursor = msgElement?.substring(0, position);
    startCursor = startCursor.substring(0, startCursor.lastIndexOf('@'));
    const end = msgElement?.substring(position);

    // Count existing mentions ONLY in the 'startCursor' portion (before cursor)
    // This tells us where the new mention will be inserted in the final DOM
    const tempStartDiv = document.createElement('div');
    tempStartDiv.innerHTML = startCursor;
    const existingMentionsCount = tempStartDiv.querySelectorAll('span[data-mentioned]').length || 0;

    const uiHtml = `<span data-mentioned="${userId}" class="mentioned blue" contenteditable="false">@${displayName}</span> `;
    text = startCursor + uiHtml + end;
    positionToUpdate = position + (uiHtml.length - 1);
    setMentionView(false);
    setGroupMemberList([]);

    // Extract mentioned user IDs from the updated HTML in the correct order
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    const mentionedSpans = tempDiv.querySelectorAll('span[data-mentioned]');
    const updatedMentioned = Array.from(mentionedSpans).map(span => span.getAttribute('data-mentioned'));

    // Update local state immediately
    setMentionedUsersIds(updatedMentioned);

    // IMPORTANT: Update the media object BEFORE state updates to ensure the data is captured
    // This is critical for Enter key selection to work correctly
    onChangeCaption(media, text, updatedMentioned);

    if (_toArray(text).length <= CAPTION_CHARACTER_LIMIT) {
      setTypingMessage(prevState => {
        return {
          ...prevState,
          value: text,
        };
      });

      // Position cursor after state update - use setTimeout to ensure DOM is updated
      setTimeout(() => {
        const contentElement = document.getElementById(getActualElementId());

        if (contentElement) {
          // Update the DOM content
          contentElement.innerHTML = text;

          // Find the newly inserted mention span by its index
          // The new span is at the position of existingMentionsCount (0-indexed)
          const allMentionSpans = contentElement.querySelectorAll('span[data-mentioned]');
          if (allMentionSpans && allMentionSpans.length > existingMentionsCount) {
            // Get the newly inserted mention span (at the index where we inserted it)
            const newMentionSpan = allMentionSpans[existingMentionsCount];
            // Position cursor after the specific mention span with a space
            positionCursorAfterLastMention(contentElement, 0, newMentionSpan);
          }
        }
      }, 10);
    }
  };

  const handleDeleteMentionedUsers = (ele) => {
    // After deletion, extract mentioned user IDs from the current HTML content
    const messageContent = document.getElementById(getActualElementId());
    if (messageContent) {
      const mentionedSpans = messageContent.querySelectorAll('span[data-mentioned]');
      const updated = Array.from(mentionedSpans).map(span => span.getAttribute('data-mentioned'));
      setMentionedUsersIds(updated);
    }
  }

  const handleSearchList = (searchChar = "") => {
    try {
      let searchValue = searchChar.includes("&amp;") === true ?
        searchChar.replace("&amp;", "&") : searchChar;
      setSearchEmoji(searchValue);
      if (searchValue.length < 1) {
        setGroupMemberList([]);
        return;
      }
      let groupParticipants = groupList.data.participants;
      let vCardUserId = vcardData.data.userId;
      let groupMemberlistsForSearch = groupParticipants.filter(participants => participants.userId !== vCardUserId);
      const searchResults = groupMemberlistsForSearch.filter(
        (ele) => ele.userProfile.nickName.toLowerCase().includes(searchValue.toLowerCase())
      );
      setGroupMemberList(searchResults)
      return searchResults;
    } catch (e) { }
  }

  // Added to Restrict User to Enter More than Allowed Characters Length
  const handleOnKeyDownListner = (e) => {
    if (
      _toArray(_get(typingMessage, "value", "")).length >= CAPTION_CHARACTER_LIMIT &&
      ALLOWED_KEY_CODES.indexOf(e.which) === -1
    ) {
      e.preventDefault();
    }
  };

  const handleMessage = ({ target }) => {
    const msgContent = document.getElementById(getActualElementId());
    const { value: targetVal } = target;

    setTypingMessage(prevState => ({
      ...prevState,
      value:
        (prevState.value.length === 0 && targetVal.trim().length === 0) ||
          (targetVal.length === 1 && targetVal === '\n')
          ? ''
          : targetVal,
    }));
    if (showCursor === true) {
      if (selectedFiles?.length > 1 && msgContent !== null) {
        let msgContent = document.getElementById(getActualElementId());
        placeCaretAtEnd(msgContent);
      } else {
        placeCaretAtEnd(msgContent);
      }
      setshowCursor(false);
    }

    // Extract mentioned user IDs from the DOM to ensure we always have the latest
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = targetVal;
    const mentionedSpans = tempDiv.querySelectorAll('span[data-mentioned]');
    const currentMentionedIds = Array.from(mentionedSpans).map(span => span.getAttribute('data-mentioned'));

    onChangeCaption(media, targetVal, currentMentionedIds);
  };

  const handleMentionList = (mentionView = false, groupList = []) => {
    setGroupMemberList(groupList)
    setMentionView(mentionView)

  }

  const handleEmptyContent = () => {
    setTypingMessage({ value: '' });
    // clear mentioned users when the content is explicitly emptied
    if (mentionedUsersIds && mentionedUsersIds.length > 0) {
      setMentionedUsersIds([]);
      // inform parent that caption and mentions are cleared
      try {
        onChangeCaption(media, '', []);
      } catch (e) { }
    }
  };


  const remainingLenthCall = (typingMessageLength = 0) => {
    if (typingMessageLength >= 975) {
      const balanceCount = CAPTION_CHARACTER_LIMIT - typingMessageLength;
      return <span className="captionCount">{balanceCount > 0 ? balanceCount : 0}</span>;
    }
    return "";
  };

  const inputListenerHandler = () => true;
  const handleOnFocus = () => true;

  useEffect(() => {
    const msgContent = document.getElementById(getActualElementId());
    if (MentionViewClicked === true || emojiSelected === true) {
      placeCaretAtEnd(msgContent)
      setMentionViewClicked(false)
      emojiSelected && setEmojiSelected(false)
    }
    if (newFile === undefined || newFile === null) {
      setshowCursor(true)
      handleMessage({ target: { value: isFirstFile ? typedMessage : "" } });
      setCursorPosition(typedMessage.length)
    }
  }, []);

  useEffect(() => {
    if (chatType === CHAT_TYPE_GROUP && filteredTextForSearch.length > 0 && filteredTextForSearch !== "") {
      const searchedList = handleSearchList(filteredTextForSearch)
      if (searchedList.length < 1) {
        setShowEmojiState(true)
      }
      else {
        setShowEmojiState(false)
      }
    }
  }, [filteredTextForSearch]);

  useEffect(() => {
    const msgContent = document.getElementById(getActualElementId());
    /** Group Chat **/
    if (chatType === CHAT_TYPE_GROUP) {
      if (groupMemberList.length > 0 && MentionView === true && showEmojiState === true) {
        setShowEmojiState(false)
      } else if (groupMemberList.length < 1 && MentionView === true && showEmojiState === false) {
        setShowEmojiState(true)
      }

      if (caption.length === position && (MentionViewClicked === true || emojiSelected === true)) {
        placeCaretAtEnd(msgContent)
        setMentionViewClicked(false)
        emojiSelected && setEmojiSelected(false);
      }
      else if ((caption.length !== position) && emojiSelected === true && (
        caption.includes("&amp;") === false && caption.includes("span") === false)) {
        emojiSelected && setEmojiSelected(false);
        setCursorPosition(position);
        setCaretPosition(msgContent, position);
      }
      else if (MentionViewClicked === true || emojiSelected === true) {
        setCursorPosition(position);
        placeCaretAtEnd(msgContent);
        emojiSelected && setEmojiSelected(false);
        MentionViewClicked && setMentionViewClicked(false);
      }
    } else if (caption.length === position && emojiSelected === true) {
      placeCaretAtEnd(msgContent)
      emojiSelected && setEmojiSelected(false);
    } else if ((caption.length !== position) && emojiSelected === true && caption.includes("&amp;") === false) { //&& (caption.includes("&amp;") === false && caption.includes("span") === false)
      emojiSelected && setEmojiSelected(false);
      setCursorPosition(position);
      setCaretPosition(msgContent, position);
    } else if (emojiSelected === true) {
      emojiSelected && setEmojiSelected(false);
      setCursorPosition(position);
      placeCaretAtEnd(msgContent);
    }

    if (caption.length > 0) {
      handleMessage({ target: { value: caption } }); //captionValue has been set
    }
    if (chatId) {
      setId("image-preview-$typingContainer");
    }
  }, [caption]);

  const { value = "" } = typingMessage;

  const handleshowEmoji = (isClicked = false) => {
    // Capture the caption caret before the emoji picker steals focus,
    // so the emoji is inserted at the real cursor (not spliced into HTML).
    captureCaptionRange();
    setShowEmojiState(isClicked)
    if (isClicked === true) {
      const messageContent = document.getElementById(getActualElementId());
      const messageContent1 = typingMessage.value;
      if (chatType === CHAT_TYPE_GROUP) {
        let groupMemberList = groupMembers.data.participants;
        let groupLists = groupMemberList?.filter(participants => participants.userId !== vcardData.data.userId);
        groupLists = groupLists.map((obj) => {
          obj.rosterData = getUserDetails(obj.userId)
          return obj;
        });
        const lastIndex = messageContent1?.lastIndexOf('@');
        const result = messageContent1?.substring(lastIndex - 1, lastIndex);
        if ((lastIndex < 0 === false) && result.length < 1 || result === ' ') {
          setMentionView(true)
          if (searchEmoji !== "" && MentionView === true) {
            handleSearchList(searchEmoji);
          } else if (MentionView === true) setGroupMemberList(groupLists);
        }

        if (position === typingMessage.value.length &&
          (typingMessage.value.includes('&amp;') === true)) {
          placeCaretAtEnd(messageContent)
        } else {
          setCursorPosition(position);
          setCaretPosition(messageContent, position);
        }
      }
    }
  }

  const handleSearchEmojiView = (searchValue = "") => {
    setSearchEmoji(searchValue);
  }

  return (
    <div className="uploadImageCaption">
      <div className="message-area-container">
        <div className="message-area" id={`video-caption-${props?.uniqueId}`}>
          {/* Capture the caption caret on mousedown (before the click moves focus)
              so the emoji is inserted at the real cursor, not at the start. */}
          <span style={{ display: 'contents' }} onMouseDownCapture={captureCaptionRange}>
            <WebChatEmoji
              emojiState={handleshowEmoji}
              onEmojiClick={handleEmojiText}
              showEmoji={showEmojiState}
            />
          </span>
          <ContentEditable
            ref={captionRef}
            handleMentionView={handleMentionList}
            captionCount={true}
            captionLength={value}
            chatType={chatType}
            handleSearchView={handleSearchEmojiView}
            id={`${id}-${uniqueId}`}
            handleMessage={handleMessage}
            handleSendTextMsg={onClickSend}
            onInputListener={inputListenerHandler}
            handleOnFocus={handleOnFocus}
            placeholder={"Add a caption"}
            setCursorPosition={setCursorPosition}
            setSelectedText={setSelectedText}
            onKeyDownListner={handleOnKeyDownListner}
            handleDeleteMentionedUser={handleDeleteMentionedUsers}
            handleEmptyContent={handleEmptyContent}
            html={removeMoreNumberChar(CAPTION_CHARACTER_LIMIT, value)}
          />
          {chatType === CHAT_TYPE_GROUP && groupMemberList.length > 0 && MentionView && showEmojiState === false && (
            <OutsideClickHandler onOutsideClick={() => handleMentionList(false, [])}>
              <MentionUserList handleMentionedData={handleMentionedUser} GroupParticiapantsList={groupMemberList} />
            </OutsideClickHandler>
          )}

          {chatType === CHAT_TYPE_GROUP && groupMemberList.length > 0 && MentionView && showEmojiState === true && (
            <MentionUserList handleMentionedData={handleMentionedUser} GroupParticiapantsList={groupMemberList} />
          )}
          {remainingLenthCall(_toArray(_get(typingMessage, "value", "")).length)}

        </div>
      </div>
    </div>
  );
};

export default Caption;

Caption.propTypes = {
  onChangeCaption: PropTypes.func,
  media: PropTypes.object,
  onClickSend: PropTypes.func,
  chatType: PropTypes.string,
  uniqueId: PropTypes.string,
  chatId: PropTypes.string,
  newFile: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  selectedFiles: PropTypes.array,
};